// extracted by mini-css-extract-plugin
export var borderRadius = "_bj-4";
export var large = "_bj-3";
export var logoContainer = "_bj-0";
export var nameLogo = "_bj-2";
export var small = "_bj-1";